export const UMB_BOOLEAN_VALUE_SUMMARY_ALIAS = 'Umb.ValueSummary.Boolean' as const;
